module.exports = __WEBPACK_EXTERNAL_MODULE_2__;


//////////////////
// WEBPACK FOOTER
// external "@material/react-ripple/dist/index.js"
// module id = 2
// module chunks = 16 17 20 21 22 23 24 25 32 33 36 37 38 39 52 53 54 55 56 57